// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fC","advertDetailParameterList__header":"c-p_fE","advertDetailParameterList__list":"c-p_fF"};